module.exports = __webpack_public_path__ + "static/img/2.dd348c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/22/2.png
// module id = PvLS
// module chunks = 0